import { ContainerModule } from 'inversify'
import T from '../../config/inversify.types'
import { SocketServiceImpl } from './socket.service.impl'

export const SocketModule = new ContainerModule((bind) => {
    bind(T.SocketService).to(SocketServiceImpl).inSingletonScope()
})
